<template>
  <master-page>
    <br/>
    <v-card>

      <v-card-title>
        <v-icon large left>mdi-chart-areaspline-variant</v-icon>
        <span class="title font-weight-light">Projeto</span>
        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Novo()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Atualizar()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>

        <v-expansion-panels focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>Filtros</v-expansion-panel-header>
            <v-expansion-panel-content class="mt-5">
              <v-row>
                <v-col cols="12" sm="3" md="2">
                  <v-text-field label="Código" v-model="filtro.id" dense outlined/>
                </v-col>
                <v-col cols="12" sm="9" md="6">
                  <v-text-field label="Nome" v-model="filtro.nome" dense outlined/>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-select v-model="filtro.tipoId" :items="tipoProjetos" item-value="id" item-text="nome" label="Tipo" dense outlined/>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-select v-model="filtro.aberto" :items="situacao" item-value="id" item-text="nome" label="Situação" dense outlined/>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-spacer/>
                <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-card-title>

      <v-card-text>
        <div class="cards-totalizadores-container mb-4">
          <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
            <div class="d-flex">
              <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
              </v-avatar>
              <div>
                <div class="totalizador-titulo">{{ card.titulo }}</div>
                <div class="totalizador-valor">{{ card.valor }}</div>
                <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
              </div>
            </div>
          </v-card>
        </div>

        <v-data-table id="tabela" :headers="headers" :items="lista" :sort-by="['id']" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.dataInicio`]="{ item }">
            {{new Date(item.dataInicio).ddmmyyyy()}}
          </template>
          <template v-slot:[`item.dataTermino`]="{ item }">
            {{item.dataTermino ? new Date(item.dataTermino).ddmmyyyy() : ''}}
          </template>
          <template v-slot:[`item.aberto`]="{ item }">
            {{item.aberto.toSimNao()}}
          </template>
        </v-data-table>

        <v-overlay :value="primeiraCarga">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

      </v-card-text>

      <cadastro-projeto v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()"/>

    </v-card>
  </master-page>
</template>

<script>
import {ProjetoService} from '@/core/services/projetos';
import {Projeto} from '@/core/domain/projetos';
import { TipoProjetoService } from '../../../core/services/projetos';

const totalizadoresPadrao = () => ({
  totalProjeto: 0,
  totalProjetoAbertos: 0,
  totalProjetoFechados: 0,
  valorTotalEstimadoAtividadesProjetosAbertos: 0
});

export default {
  data: () => ({
    service: new ProjetoService(),
    item: new Projeto(),
    totalLista: 0,
    lista: [],
    dialogCadastro: false,
    loading: true,
    loadingTotalizadores: false,
    options: {
      itemsPerPage: 15
    },
    headers: [
      { text: '', value:'actions', sortable: false  },
      { text: 'Código', value: 'id' },
      { text: 'Nome', value: 'nome' },
      { text: 'Tipo', value: 'tipoProjeto.nome' },
      { text: 'Inicial', value: 'dataInicio', type:'date' },
      { text: 'Termino', value: 'dataTermino', type:'date' },
      { text: 'Aberto', value: 'aberto', type:'boolean' },
    ],
    primeiraCarga: true,
    filtro: {
      id: null,
      nome: '',
      tipoId: null,
      aberto: true
    },
    situacao: [
      {id: null, nome: "TODOS"},
      {id: true, nome: "Aberto"},
      {id: false, nome: "Fechado"}
    ],
    tipoProjetos: [],
    tipoProjetoService: new TipoProjetoService(),
    totalizadores: totalizadoresPadrao()
  }),
  computed: {
    cardsTotalizadores(){
      return [
        {
          chave: 'total-projeto',
          titulo: 'Total projeto',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalProjeto,
          subtitulo: 'Todos os projetos filtrados',
          icone: 'mdi-briefcase-outline',
          corFundo: '#edf2f7',
          corBorda: '#d4dde8',
          corIconeFundo: '#dfe7f1',
          corIcone: '#3f5d7a'
        },
        {
          chave: 'projeto-aberto',
          titulo: 'Total projeto abertos',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalProjetoAbertos,
          subtitulo: 'Situação aberta',
          icone: 'mdi-folder-open-outline',
          corFundo: '#eaf6ef',
          corBorda: '#d3e8dc',
          corIconeFundo: '#dceddf',
          corIcone: '#2f6f4f'
        },
        {
          chave: 'projeto-fechado',
          titulo: 'Total projeto fechados',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalProjetoFechados,
          subtitulo: 'Situação fechada',
          icone: 'mdi-folder-lock-outline',
          corFundo: '#fff5e9',
          corBorda: '#f0dfc8',
          corIconeFundo: '#f8e9d4',
          corIcone: '#8a5a21'
        },
        {
          chave: 'custo-estimado-abertos',
          titulo: 'Valor estimado atividades (abertos)',
          valor: this.loadingTotalizadores ? '-' : Number(this.totalizadores.valorTotalEstimadoAtividadesProjetosAbertos || 0).toMoeda(true),
          subtitulo: 'Ignora apenas o filtro de situação',
          icone: 'mdi-cash-multiple',
          corFundo: '#f1eef9',
          corBorda: '#ddd6ee',
          corIconeFundo: '#e7e1f4',
          corIcone: '#5d4c8c'
        }
      ];
    }
  },
  watch:{
    options: {
      handler(){
        this.Atualizar();
      },
      deep: true
    },
    lista: function(){
      if(this.primeiraCarga)
        this.primeiraCarga = false;
    }
  },
  methods: {
    Novo(){
      this.item = new Projeto();
      this.dialogCadastro = true;
    },
    Atualizar(){
      this.loading = true;
      this.loadingTotalizadores = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro, "TipoProjeto").then(
        res => {
          this.lista = res.data.items;
          this.totalLista = res.data.count;
        },
        err => {
          this.$swal('Aviso', err.response.data, 'error')
        }
      ).finally(() => {
        this.loading = false;
      });

      this.service.TotalizadoresComFiltro(this.search, this.headers, this.filtro, "TipoProjeto").then(
        res => {
          this.totalizadores = res.data;
        },
        err => {
          this.totalizadores = totalizadoresPadrao();
          this.$swal('Aviso', err.response.data, 'error');
        }
      ).finally(() => {
        this.loadingTotalizadores = false;
      });
    },
    Editar(item){
      this.service.ObterPorId(item.id, "TipoProjeto, Atividades, Beneficiarios.Beneficiario, Pessoais.Pessoal, Atividades.Itens").then(
        res =>{
          this.item = Object.assign({}, new Projeto(res.data));
          this.dialogCadastro = true;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      )
    },
    Excluir(item){
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja excluir o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.service.Excluir(item.id)
            .then(res => {
              if (res.status == 200){
                return res;
              }
            },
            err => this.$swal('Aviso', err.response.data, 'error'))
          },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if(result.value) {
          this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
          this.Atualizar();
        }
      })
    }
  },
  mounted(){
    this.tipoProjetoService.ListarTudo().then(
      res => {
        this.tipoProjetos = res.data.items;
        this.tipoProjetos.unshift({
          id: null,
          nome: "TODOS"
        })
      }
    );

    this.Atualizar();
  }
}
</script>
<style scoped>
.totalizador-card {
  border-width: 1px;
  border-style: solid;
  min-height: 108px;
  width: clamp(220px, 18vw, 280px);
}

.cards-totalizadores-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(10px, 1.2vw, 20px);
}

@media (max-width: 600px) {
  .totalizador-card {
    width: 100%;
  }
}

.totalizador-titulo {
  font-size: 12px;
  color: #5f6a77;
  font-weight: 600;
  line-height: 1.3;
}

.totalizador-valor {
  font-size: 30px;
  font-weight: 700;
  color: #202b37;
  line-height: 1.1;
}

.totalizador-subtitulo {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
</style>
